import React, { useState, useEffect } from 'react';

interface ImageCarouselProps {
  images: string[];
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, images.length]);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    setIsAutoPlaying(false);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    setIsAutoPlaying(false);
  };

  const getCardStyle = (index: number) => {
    const diff = index - currentIndex;
    const totalImages = images.length;
    
    let position = diff;
    if (diff > totalImages / 2) position = diff - totalImages;
    if (diff < -totalImages / 2) position = diff + totalImages;

    const isActive = position === 0;
    const isPrev = position === -1;
    const isNext = position === 1;
    const isVisible = Math.abs(position) <= 1;

    return {
      transform: `
        translateX(${position * 85}%) 
        scale(${isActive ? 1 : 0.8}) 
        rotateY(${position * 20}deg)
      `,
      opacity: isVisible ? (isActive ? 1 : 0.3) : 0,
      zIndex: isActive ? 3 : (isPrev || isNext ? 2 : 1),
      pointerEvents: isActive ? 'auto' : 'none',
      visibility: isVisible ? 'visible' : 'hidden',
    };
  };

  return (
    <div className="carousel-container-3d">
      <div className="carousel-stage">
        {images.map((image, index) => (
          <div
            key={index}
            className="carousel-card"
            style={getCardStyle(index) as React.CSSProperties}
          >
            <img 
              src={image} 
              alt={`Inner Wealth Moment ${index + 1}`}
              className="carousel-card-image"
            />
          </div>
        ))}

        {/* Navigation Arrows on Edges */}
        <button 
          onClick={goToPrevious}
          className="carousel-nav-btn carousel-nav-left"
          aria-label="Previous"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>
        
        <button 
          onClick={goToNext}
          className="carousel-nav-btn carousel-nav-right"
          aria-label="Next"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ImageCarousel;
